import { amountToDisplayValue } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ReactElement } from 'react'

interface ExpertProfitAndLossResultHeaderProps {
  currencyId?: string
  value: number
}

export const ExpertProfitAndLossResultHeader = ({
  currencyId,
  value,
}: ExpertProfitAndLossResultHeaderProps): ReactElement => (
  <Typography.Text color={colors.content.neutral.medium} weight="semibold">
    {amountToDisplayValue(value, false, currencyId)}
  </Typography.Text>
)
